import {writable} from "svelte/store";

export const selectedIds = writable<Array<number>>([]);
export const selectedWorkoutIds = writable<Array<number>>([]);
